export default __webpack_public_path__ + "static/distribuidor-desguace-4490396005b72036b585f29adb71a486.pdf";